<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Product Details'
                    : 'Deleted Product Details'
                "
              ></h3>
              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/products/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>

            <!-- Product Information Section -->
            <v-card-text v-if="product">
              <v-card outlined class="mb-4">
                <v-card-title class="primary white--text">
                  <v-icon left color="white">mdi-package-variant</v-icon>
                  Product Information
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="mb-3">
                        <strong>Product Name:</strong>
                        <p class="text-h6 mt-1">{{ product.name }}</p>
                      </div>
                      <div class="mb-3">
                        <strong>Description:</strong>
                        <p class="mt-1">{{ product.description || 'N/A' }}</p>
                      </div>
                      <div class="mb-3">
                        <strong>Ratings:</strong>
                        <v-rating
                          :value="parseFloat(product.ratings) || 0"
                          color="amber"
                          dense
                          half-increments
                          readonly
                          size="20"
                          class="mt-1"
                        ></v-rating>
                        <span class="ml-2">{{ product.ratings || 'N/A' }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="mb-3">
                        <strong>Category Path:</strong>
                        <div v-if="product.category" class="mt-2">
                          <v-breadcrumbs
                            :items="getCategoryPath(product.category)"
                            divider=">"
                            class="pa-0"
                          >
                            <template v-slot:item="{ item }">
                              <v-breadcrumbs-item>
                                <v-chip small color="primary" text-color="white">
                                  {{ item.text }}
                                </v-chip>
                              </v-breadcrumbs-item>
                            </template>
                          </v-breadcrumbs>
                        </div>
                        <span v-else class="grey--text">No category assigned</span>
                      </div>
                      <div class="mb-3">
                        <strong>Delivery Type:</strong>
                        <v-chip
                          small
                          :color="product.delivery_type === 0 ? 'success' : 'info'"
                          text-color="white"
                          class="ml-2"
                        >
                          {{ product.delivery_type === 0 ? 'FREE DELIVERY' : 'PAID DELIVERY' }}
                        </v-chip>
                      </div>
                      <div v-if="product.delivery_type === 1" class="mb-3">
                        <strong>Delivery Charges:</strong>
                        <p class="mt-1">₹{{ product.delivery_amount }}</p>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-card-text>

            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="size"
                    solo
                    rounded
                    v-model="filter.size"
                    :items="sizeItems"
                    clearable
                    @click:clear="(filter.size = null), (page = 1)"
                    label="Size"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="color"
                    solo
                    rounded
                    v-model="filter.color"
                    :items="colorItems"
                    clearable
                    @click:clear="(filter.color = null), (page = 1)"
                    label="Color"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 4000px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="550"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start" style="min-width: none">Color</th>
                      <th class="text-start">Size</th>
                      <th class="text-start">Price</th>
                      <!-- <th class="text-start">Discount</th>
                      <th class="text-start">quantity</th> -->

                      <!-- <th class="text-start">Image</th> -->
                      <th class="text-right action_th">QR Code</th>
                    </tr>
                  </thead>
                  <tbody v-if="product_variants.length != 0">
                    <tr
                      v-for="(product_variant, i) in product_variants"
                      :key="`product_variant_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': product_variants.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <!-- <td>
                        <v-tooltip bottom v-if="product_variant.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Product is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="product_variants.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Product is InActive</span>
                        </v-tooltip>
                      </td> -->
                      <td>
                        {{ product_variant.color || "" }}
                      </td>
                      <td>
                        {{ product_variant.size || "" }}
                      </td>
                      <td>₹ {{ product_variant.price || "" }}</td>
                      <!--  <td>
                        {{
                          product_variant.discount_percentage
                            ? product_variant.discount_percentage + "%"
                            : ""
                        }}
                      </td>
                      <td>
                        {{ product_variant.quantity || "" }}
                      </td> -->
                      <td class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              color="primary"
                              @click="downloadVariantQR(product_variant)"
                              :loading="downloadingId === product_variant.id"
                            >
                              <v-icon dark>mdi-qrcode-scan</v-icon>
                            </v-btn>
                          </template>
                          <span>Download QR Code</span>
                        </v-tooltip>
                      </td>
                      <!-- <td>
                        <v-btn
                          icon
                          text
                          :href="`${mediaUrl}${product.image_path}`"
                          color="primary"
                          target="_blank"
                        >
                          <v-icon>mdi-file-document-edit-outline</v-icon>
                        </v-btn>
                      </td> -->
                      <!-- <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(product.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Product</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/products/${encryptIt(product.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Products</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(product.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this product</span>
                          </v-tooltip>
                        </template>
                      </td> -->
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_product" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>product deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_product = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_product" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Product restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_product = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import QRCode from "qrcode";
import { downloadVariantQrLabel } from "@/utils/variantQr";
// import { forEach } from "core-js/core/array";
export default {
  name: "productsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      product: null, // Product details
      product_variants: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],

      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      colorItems: [],
      sizeItems: [],
      downloadingId: null,
      // isExcelloading: false,
      delete_product: false,
      is_deleted_product: false,
      restore_product: false,
      is_restored_product: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getProductDetails();
      this.getData();
    },
  },
  mounted() {
    this.getProductDetails();
    this.getData();
    this.getMasters();
  },
  methods: {
    getCategoryPath(category) {
      const path = [];
      let current = category;

      // Build path from current category to root
      while (current) {
        path.unshift({
          text: current.name,
        });
        current = current.parent_category || current.parentCategory;
      }

      return path;
    },

    async getProductDetails() {
      if (!this.$route.params.productId) return;

      try {
        const response = await axios.get(
          `/products/${this.$route.params.productId}`
        );
        if (response.data.success) {
          this.product = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    },

    async getMasters() {
      await axios
        .get(`masters?context=colorAndsize`)
        .then((masters) => {
          masters = masters.data;
          //documents
          masters.colors.forEach((color) => {
            this.colorItems.push({
              id: color.id,
              text: color.description,
              value: color.code,
            });
          });
          //user
          masters.sizes.forEach((size) => {
            this.sizeItems.push({
              id: size.id,
              text: size.description,
              value: size.code,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      if (this.$route.params.productId) {
        this.filter.product_id = this.decryptIt(this.$route.params.productId);
      } else {
        this.filter.product_id = "";
      }
      console.log("Product", this.filter.product_id);

      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.size = this.filter.size ? this.filter.size : "";
      this.filter.color = this.filter.color ? this.filter.color : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&product_id=" +
        this.filter.product_id +
        "&is_active=" +
        this.filter.is_active +
        "&size=" +
        this.filter.size +
        "&color=" +
        this.filter.color +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`products_variants?${query}`)
        .then((response) => {
          this.product_variants = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_product = true;
      await axios
        .post(`/products/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_product = false;
          this.is_deleted_product = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_product = true;
      await axios
        .post(`/products/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_product = false;
          this.is_restored_product = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    getVariantUrl(variantId) {
      // The public variant page decrypts this id, so it must be encrypted here
      const encryptedId = this.encryptIt(variantId.toString());

      const baseUrl = window.location.origin;
      return `${baseUrl}/variant/${encryptedId}`;
    },
    async downloadVariantQR(variant) {
      this.downloadingId = variant.id;

      try {
        const variantUrl = this.getVariantUrl(variant.id);

        // Generate QR code as data URL
        const qrDataUrl = await QRCode.toDataURL(variantUrl, {
          width: 300,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#FFFFFF",
          },
        });

        // Same composite label as the QR codes page (name, variant, code, price)
        await downloadVariantQrLabel({
          qrSource: qrDataUrl,
          variant: {
            ...variant,
            product: variant.product || this.product,
          },
        });
      } catch (error) {
        console.error("Error generating QR code:", error);
        this.$toast.error("Failed to generate QR code. Please try again.");
      } finally {
        this.downloadingId = null;
      }
    },
  },
};
</script>
